import React from 'react';
import Button from '../../../button/index';
import './index.css';
import {Link} from 'react-router-dom';

function DropDownItem ({component, link, onClick, picto, title}) {
	if(link){
		return (
			<li>
				<Link
					className="drop-down-item btn-link"
					title={title || ''}
					to={link}
				>
					<div className="drop-down-item__picto">
						{picto}
					</div>
					<div className="drop-down-item__text">
						{title}
					</div>
				</Link>
			</li>
		)
	} else {
		return (
			<Button
				className="drop-down-item btn-link"
				title={title || ''}
				onClick={onClick}
			>
				<div className="drop-down-item__picto">
					{picto}
				</div>
				<div className="drop-down-item__text">
					{title}
				</div>
			</Button>
		)
	}

}

export default DropDownItem;
